export default __webpack_public_path__ + "static/media/objetivo-4.605ddf9d.svg";